import { FC } from 'react'
import { get } from 'es-toolkit/compat'
import useObjFromList from 'core/hooks/useObjFromList'
import { ICountry } from 'core/api/rest/queries/upward-forecast-country'
import useSelector from 'core/hooks/useSelector'
import { FILTERS_LABELS_COUNTRIES, FILTERS_SELECTS_COUNTRIES } from '../../../core/constants/translations/filters'
import { useCountries } from '../../../core/api/country/useCountries'
import { Combobox } from '../../common/mygame/combobox/combobox'
import { processComboboxChange } from '../../../core/utils/combobox'
import { useTranslation } from 'react-i18next'

type SelectCountryProps = {
  id?: string
  className?: string
  label?: string
  value?: string
  onChange?: (value: string) => void
  isDisabled?: boolean
  isLoading?: boolean
  isMultiple?: boolean
  disabledItemsIds?: number[]
}

type DumbSelectCountryProps = SelectCountryProps & {
  data?: ICountry[]
}

export type Country = {
  id: string
  label: string
}

const sortCountry = (countryA: ICountry, countryB: ICountry) => {
  const countryALabel = countryA.label
  const countryBLabel = countryB.label
  if (countryALabel < countryBLabel) {
    return -1
  }
  return countryALabel === countryBLabel ? 0 : 1
}

const getCountriesSorted = data => {
  const sortedData = [...data]
  sortedData.sort(sortCountry)
  return sortedData
}

export const DumbSelectCountry: FC<DumbSelectCountryProps> = ({
  label,
  value,
  onChange,
  data = [],
  isLoading,
  isDisabled,
  disabledItemsIds = []
}) => {
  const { t } = useTranslation()
  const countriesSorted = getCountriesSorted(data)
  const countrySelected: Country = useObjFromList(countriesSorted, 'id')[value] ?? null
  const placeholder = isLoading && !data.length ? t('loading') : t(FILTERS_SELECTS_COUNTRIES)

  const handleChangeCombobox = (value, actionMeta) => {
    processComboboxChange(value, actionMeta, onChange, data, disabledItemsIds)
  }

  return (
    <Combobox<Country>
      onChange={handleChangeCombobox}
      value={countrySelected}
      comboboxLabel={label || t(FILTERS_LABELS_COUNTRIES)}
      options={countriesSorted}
      testId="country"
      isDisabled={isDisabled}
      isLoading={isLoading}
      placeholder={placeholder}
    />
  )
}

export const SelectCountry = (props: SelectCountryProps) => {
  const value = useSelector(state => get(state, 'filters.country'))
  const { data: countries, isLoading: loading } = useCountries()
  return <DumbSelectCountry data={countries || []} value={value} isLoading={loading} {...props} />
}

export default SelectCountry
